var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: !_vm.inert && "_btnh",
      on: {
        mouseover: _vm.mouseover,
        mouseleave: _vm.mouseleave,
        mousedown: _vm.mousedown,
        mouseup: _vm.mouseup,
        touchstart: _vm.mousedown,
        touchend: _vm.mouseup,
        click: _vm.fwd
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }